import { MainPageContent } from "@/routes/_components/main-page";
import { CommitmentsTableFilters } from "@/services/backend/relationships/components/commitments-table";
import { useState } from "react";
import { ListCommitmentsRequest } from "@/services/backend/relationships/api/service";
import { Commitment } from "@/services/backend/relationships/types/relationship";
import { CommitmentsPlanningTable } from "@/routes/commitments/_components/commitments-planning-table";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Alert403 } from "@/shared/components/alerts/alert-403";

export function CommitmentsRoute() {
  const [request, setRequest] = useState<ListCommitmentsRequest>({
    orderBy: [{ field: "date" }],
    limit: 50,
  });
  const [selection, setSelection] = useState<Commitment[]>([]);

  const canAccess = useFeatureAuth("gsm.commitments");
  if (!canAccess) {
    return (
      <MainPageContent>
        <Alert403 />
      </MainPageContent>
    );
  }

  return (
    <MainPageContent>
      <PersistenceContextProvider>
        <div className="grid gap-2">
          <div className="flex">
            <CommitmentsTableFilters
              request={request}
              onRequestChange={setRequest}
              selection={selection}
              onSelectionChange={setSelection}
              hideCompanyFilter={false}
              hideBranchFilter={false}
              hideCustomerFilter={false}
              hideServiceObjectFilter={false}
              hideServiceKindFilter={false}
              hideCreateSeries
            />
            <PersistenceStateUsingContext className="mr-1 ml-auto" />
          </div>
          <CommitmentsPlanningTable
            request={request}
            onRequestChange={setRequest}
            selection={selection}
            onSelectionChange={setSelection}
          />
        </div>
      </PersistenceContextProvider>
    </MainPageContent>
  );
}
